import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dhasboard',
  templateUrl: './dhasboard.component.html',
  styles: []
})
export class DhasboardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
